import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import {
    getStringWithoutHtml,
    nsSite,
    normalizeString,
    compareDateIsOlder,
} from "helpers";
import {
    getTypeNews,
    getTypeNewsForAnalitics,
} from "../helpers";
import { sizeBanner } from "@/shared/DFP/News/mapping";
import { BannerCollapse } from "@/shared/ContentBanner";

export const useVideo = (props) => {

    const { content, ...rest } = props;

    const [innerWidth, setInnerWidth] = useState(0);
    const [latestVideoRigthColumn, setLatestVideoRigthColumn] = useState([]);
    const [bucketsHeader, setBucketsHeader] = useState([]);
    const [newsToday, setNewsToday] = useState([]);
    const router = useRouter();

    const loadRigthColumn = async () => {
        const fetchLatestVideo = await fetch("/api/latest/video/10");
        const dataLatestVideo = await fetchLatestVideo.json();
        setLatestVideoRigthColumn({ name: "LatestVideoRigthColumn", content: dataLatestVideo?.data ?? [] });
    }
    const loadLiveblog = async () => {
        const fetchLiveblogs = await fetch("/api/menus/liveblogs");
        const dataLiveblogs = await fetchLiveblogs.json();
        const data = dataLiveblogs?.data?.items;
        setBucketsHeader({ liveblogs: data ?? [] });
    }
    const loadNewsToday = async () => {
        const fetchNewsToday = await fetch("/api/menus/noticiashoy");
        const dataNewsToday = await fetchNewsToday.json();
        const data = dataNewsToday?.data?.items?.length > 0 ? dataNewsToday.data.items : [];
        setNewsToday(data);
    }

    useEffect(() => {
        if (document) {
            setInnerWidth(document.body.clientWidth);
        }
        if (typeof window.getRewarded == 'undefined') {
            window.getRewarded = () => { setShowRewarded(true) }
        }
        loadRigthColumn();
        loadLiveblog();
        loadNewsToday();
    }, []);

    const relatedLatestVideo = Array.isArray(rest?.properties?.latestVideo)
        ? rest.properties.latestVideo
        : [];

    const sectionName = content?.sections?.[0]?.name ? content.sections[0].name : "";
    const sectionNameAds = sectionName?.replace(/\s+/g, "-")?.toLowerCase();

    const sectionUrl = content?.sections?.[0]?.url;
    const sectionId = content?.sections?.[0]?._id;

    const sectionData = {
        name: sectionName,
        url: !!sectionUrl ? sectionUrl : "",
    };

    const parseSummary = getStringWithoutHtml(content?.summary);
    const parseDescription = getStringWithoutHtml(content?.description);

    const dataImageShare = {
        desktop: { image: content?.thumbnail },
        mobile: { image: content?.thumbnail },
    };

    const sectionIdJWPlayer = content?.sections?.[0]?.metadata?.idJWPlayer
        ? content.sections[0].metadata.idJWPlayer
        : process.env.NEXT_PUBLIC_JWPLAYER_ID;

    const typeWeb = getTypeNews(content?.metadata?.typeWeb, content?.specialAuthors);

    const dataAnalitics = {
        asPath: router.asPath,
        name: `noticias.${content?.gtm_name}`,
        newsType: getTypeNewsForAnalitics(typeWeb),
        notaId: content?._id,
        nsSite: nsSite(content?.sections),
        pageType: "multimedia",
        publishedDate: content?.publishedDate ?? new Date(),
        sections: normalizeString(sectionName),
        section: sectionName,
        summary: parseSummary,
        tags: content?.tags,
        authors: content?.authors?.[0]?.name
            ? content.authors[0].name
            : "Redacción Clarín",
        thumbnail: dataImageShare?.mobile?.image
    };

    const dataMeter = {
        tags: content?.tags,
        metadata: "",
        pageType: "news",
        section: content?.sections?.[0]?.url?.replace(/\//g, ","),
        mainSectionTree: "",
        authors: null,
        paywall: "free",
        typeWeb: content?.metadata?.typeWebView,
        sectionNames: normalizeString(sectionName),
        authorName: content?.authors?.[0]?.name
            ? content.authors[0].name
            : "Redacción Clarín",
        newsId: content?._id,
        category: "video"
    };

    const rightColumn = [
        { name: "Banner", bannerId: "caja0" },
        { 
            name: "BannerLazy", 
            bannerId: "auspicio", 
            container: BannerCollapse,
            adsPath: "video/nota",
            mapping: sizeBanner.auspicio
        },
        latestVideoRigthColumn ?? { name: "" },
        { 
            name: "BannerLazy", 
            bannerId: "caja1",
            container: BannerCollapse,
            adsPath: "video/nota",
            mapping: sizeBanner.caja1
        },
        { 
            name: "BannerLazy", 
            bannerId: "caja2",
            container: BannerCollapse,
            adsPath: "video/nota",
            mapping: sizeBanner.caja2
        },
        { 
            name: "BannerLazy", 
            bannerId: "caja3",
            container: BannerCollapse,
            adsPath: "video/nota",
            mapping: sizeBanner.caja3
        },
        {
            name: "BannerLazy",
            bannerId: "caja4",
            adsPath: "video/nota",
            mapping: sizeBanner.caja4
        },
        {
            name: "BannerLazy",
            bannerId: "caja0b",
            adsPath: "video/nota",
            mapping: sizeBanner.caja0b
        },
    ];

    const modificatedAtIsOlder = compareDateIsOlder(content?.lastModified, content?.publishedDate);

    const menu = rest?.menu ?? {};

    return {
        ...rest,
        preview: rest?.preview ?? false,
        isPreview: rest?.preview ?? false,
        widgets: rest?.widgets ?? [],
        menu,
        formatContent: {
            ...content,
            sectionNameAds,
            sectionAdsPath: "video",
            dataAnalitics,
            dataMeter,
            relatedLatestVideo,
            sectionIdJWPlayer,
            parseDescription,
            innerWidth,            
            dataHead: {
                dataImageShare,
                lastModified: modificatedAtIsOlder ? content?.lastModified : content?.publishedDate,
                menu,
                publishedDate: content?.publishedDate,
                relatedVideos: content,
                sectionId,
                sectionUrl,
                sections: content?.sections,
                subtitle: content?.subtitle,
                summary: parseDescription,
                title: content?.name,
                url: content?.url,
                relAmp: false,
            },
            dataHeader: {
                liveblogs: bucketsHeader.liveblogs,
                menu,
                sectionData,
                isPreview: rest?.preview ?? false,
                isNews: true,
                newsToday,
            },
            storyContainer: {
                data: {
                    authors: content?.authors,
                    authorPlace: content?.authorPlace,
                    socialNetworkingSelect: ["facebook", "twitter", "whatsapp", "share"],
                    title: content?.title,
                    url: content?.url,
                    publishedDate: content?.publishedDate,
                    modificatedAt: content?.modificatedAt,
                    includeTimeZone: content?.includeTimeZone,
                    tags: content?.tags,
                    widgets: rightColumn,
                }
            }
        },
    }
}